import { useDisclosure } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React, { memo, useMemo } from 'react'
import { useLabels } from '../../../../utils/hooks/useLabels/useLabels'
import text from '../../../../utils/locale/languages/ES/Es.json'

const forActiveStyles = {
  textAlign: 'start',
  width: 'max-content',
  textDecoration: 'underline',
  color: 'blue',
  cursor: 'pointer',
}

export const statusCardTypes = {
  AC: text.card_active,
  BL: text.card_locked,
  DF: text.card_defective,
  DV: text.card_unlinked,
  EM: text.card_issued,
  NG: text.card_not_generated,
  PS: text.card_for_request,
  RP: text.card_replacement,
  RZ: text.card_rejected,
  SO: text.card_requested,
  SU: text.card_suspended,
  VE: text.card_expired,
}

const StatusCardCell = ({ value }) => {
  const { isOpen, onClose, onOpen } = useDisclosure()
  const { texts } = useLabels()
  const label = useMemo(
    () => statusCardTypes[value],
    [texts.active, texts.unactive, texts.unlinked, value],
  )

  return (
    <>
      <div
        onClick={['PA', 'RA'].includes(value) ? onOpen : null}
        style={
          ['PA', 'RA'].includes(value)
            ? forActiveStyles
            : {
                textAlign: 'left',
              }
        }
      >
        {label}
      </div>
    </>
  )
}

StatusCardCell.propTypes = {
  value: PropTypes.string,
}

export default memo(StatusCardCell)
